<template>
    <section class="background-image pb-20 overflow-hidden">
        <div class=" mt-40 ">
            <div class=" w-1/2 m-auto md:w-full">
                <div>
                    <img class=" w-1/2 m-auto" src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo">
                    <p class="font-nunitosans text-2xl text-gray-400 text-center">ADMIN</p>
                </div>

                <div class=" w-4/5 m-auto  font-poppins mt-8">
                 <div class="mt-8 font-semibold text-center text-lg text-blue-600">
                    <p>RESET PASSWORD</p>
                </div>
                   
    
                <p class="text-green-500">{{message}}</p>

                            <!-- --RESET PASSWORD -->
                            <div >
                                <form @submit.prevent="_resetPassword">
                                    
                                    <div class="mt-5">
                                        <div class="mt-8 font-semibold">
                                            <p>New Password</p>
                                        </div>
                                        <div class="flex">
                                            <input v-model="password" :type="[showPassword ? 'text' : 'password']" class="border w-full border-gray-400 h-14 pl-6 rounded-2xl" name="password" id="password" placeholder="Password" >
                                            <div>
                                                <span @click="showPassword = !showPassword">
                                                    <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                                </span>
                                            </div>
                                        </div>
                                        <p v-if="passwordValidity == 'invalid' " class="text-xs text-red-500">Password must contain at least one number and greater than 8 characters</p>

                                        <div class="mt-8 font-semibold">
                                            <p>Confirm Password</p>
                                        </div>
                                        <div class="flex">
                                            <input v-model="confirmPassword" :type="[showPassword2 ? 'text' : 'password']" class="border w-full border-gray-400 h-14 pl-6 rounded-2xl" name="confirm-password" id="confirm-password" placeholder="Confirm Password" >
                                            <div>
                                                <span @click="showPassword2 = !showPassword2">
                                                    <i class="fa  -ml-8 mt-4" :class="[showPassword2 ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                                </span>
                                            </div>
                                        </div>
                                        <p v-if="confirmPasswordValidity === 'invalid'" class=" text-xs text-red-500">Password did not match</p>

                                        <p class="text-sm text-red-500">{{displayError}}</p>

                                        <div class="mt-10 flex">
                                            <button class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)">Proceed</button>
                                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>      
                    </div>  
                </div>
        
        
        
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
    components: {
    },
    data() {
        return {
            isLoading: false,
            displayError: "",
            isCodeSent: "",
            codeFailed:"",
            showPassword:false,
            showPassword2:false,
            password:"",
            passwordValidity:"",
            confirmPassword:"",
            confirmPasswordValidity:"",
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        _resetPassword(){    
            let token = this.$route.params.token
            if(!this.password || this.password.length < 8 || this.password.search(/[0-9]/) < 0) {
                this.passwordValidity = 'invalid';
            } else if(this.confirmPassword !== this.password){
                this.confirmPasswordValidity = 'invalid';
            } else {
                this.isLoading = true;
                axios({
                    method: 'post',
                    url: `${url}/v1/web/auth/reset-password?token=${token}`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        password: this.password,
                        token : this.token
                    }
                    })
                    .then((response) => {
                        response
                        this.message =  "password changed successfully"
                        setTimeout(() => {
                            this.$router.push("/admin/login")
                        }, 3000);
                    })
                    .catch((error) => {
                        this.displayError = error.response.data.message
                        this.isLoading = false;
                    })
            }
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.background-image {
    background-image:linear-gradient(rgba(255, 255, 255, 0.6), rgba(255,255,255,0.5)), url('../LandingPages/Images/image 27.png');
    background-repeat: no-repeat;    
    background-size: cover;
}
</style>